import React from 'react'
import { useDispatch } from 'react-redux'

import { OrderItemInfo } from 'appTypes/orders'
import { ItemCard } from 'components/ui/ItemCard'
import apiClient from 'helpers/clients/apiClient'
import { deleteProductFromOrder, getCart } from 'store/partials/cart/cartSlice'
import { addToSegmentOnRemoveFromCart } from 'utils/addToSegment'
import { STORAGE_KEYS } from 'utils/constants'
import { getFromStorage } from 'utils/storage'

type Props = {
  orderItemInfo: OrderItemInfo
}

export const DynamicComplementaryItem: React.FC<Props> = ({ orderItemInfo }) => {
  const dispatch = useDispatch()

  const handleIncreaseAmount = async () => {
    await apiClient.increaseOrderItemAmount(orderItemInfo.orderItem.id)
    const orderId = Number(getFromStorage(STORAGE_KEYS.orderId))
    dispatch(getCart(orderId, false))
  }

  const handleDecreaseAmount = async () => {
    await apiClient.decreaseOrderItemAmount(orderItemInfo.orderItem.id)
    const orderId = Number(getFromStorage(STORAGE_KEYS.orderId))
    dispatch(getCart(orderId, false))
  }

  const removeFromCart = () => {
    addToSegmentOnRemoveFromCart(orderItemInfo.orderItem)
    dispatch(deleteProductFromOrder(orderItemInfo.orderItem.id))
  }

  return (
    <ItemCard
      orderItemInfo={orderItemInfo}
      onIncreaseAmount={handleIncreaseAmount}
      onDecreaseAmount={handleDecreaseAmount}
      onDelete={removeFromCart}
      imageWidth={{ base: 88, md: 108 }}
      imageHeight={{ base: 88, md: 108 }}
      marginBottom="20px"
    />
  )
}
